import { XInit } from "./XObject";

export const state = XInit(
  class {
    showMenu = false;
    theme = localStorage.getItem("theme") || "light";
  }
);
